import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { PrivateRoute } from '../privateRoute.jsx';

import CardList from "../cards/cards";
import EditCard from "../cards/edit_card";
import UserList from "../user_management/users";
import EditUser from "../user_management/edit_user";
import DeviceList from "../devices/devices";
import TanksList from "../tanks/tank/tanks";
import TanksPage from "../tanks/tanks_page";
import EditDevice from "../devices/edit_device";
import EditTank from "../tanks/tank/edit_tank";
import OperationList from "../operations/operations";
import LoginPage from "../login/login_page";
import TankDetails from "../tanks/tank/tank_details.jsx"
import EditTankOperation from "../tanks/tank_operation/edit_tank_operation.jsx"
import AddAreaView from "../tanks/area/add_area_view.jsx"
import Startup from "./startup.jsx"

export default class Body extends React.Component {
    render() {
        return (
            <main>
                <Startup>
                    <Switch>
                        <Route exact path="/login" component={LoginPage}/>
                        <PrivateRoute exact path="/cards" component={CardList}/>
                        <PrivateRoute path="/cards/addCard" component={EditCard}/>
                        <PrivateRoute path="/cards/editCard/:id" component={EditCard}/>
                        <PrivateRoute exact path="/devices" component={DeviceList}/>
                        <PrivateRoute path="/devices/addDevice" component={EditDevice}/>
                        <PrivateRoute path="/devices/editDevice/:id" component={EditDevice} />
                        <PrivateRoute exact path="/tanks" component={TanksPage} />
                        <PrivateRoute exact path="/tanks/tanks" component={TanksPage} />
                        <PrivateRoute exact path="/tanks/tanksoperations" component={TanksPage} />
                        <PrivateRoute exact path="/tanks/tankstates" component={TanksPage} />
                        <PrivateRoute path="/tanks/:areaId/addTank/" component={EditTank} />
                        <PrivateRoute path="/tanks/addArea/" component={AddAreaView} />
                        <PrivateRoute path="/tanks/tankdetails/:id" component={TankDetails} />
                        <PrivateRoute path="/tanks/editTank/:id" component={EditTank} />
                        <PrivateRoute path="/tanks/:id/addtankoperation" component={EditTankOperation} />
                        <PrivateRoute exact path="/operations" component={OperationList}/>
                        <PrivateRoute exact path="/users" component={UserList}/>
                        <PrivateRoute path="/users/addUser" component={EditUser}/>
                        <PrivateRoute path="/users/editUser/:id" component={EditUser}/>
                        <Redirect from="/" to="/operations"/>
                    </Switch>
                </Startup>
            </main>
        );

    }
}